import { TZDate } from '@date-fns/tz'
import { lightFormat } from 'date-fns'
import type { TimezoneOption } from './types'

export function format(date: Date, formatStr: string, { timezone = 'UTC' }: TimezoneOption = {}): string {
  const zonedDate = new TZDate(date, timezone)
  return lightFormat(zonedDate, formatStr)
}
